import { combineReducers } from 'redux';
import { encryptPersistReducer } from 'app/libs/encryptPersistReducer';
import apply from './apply';
import method from './method';

const encarpay = combineReducers({
	apply: encryptPersistReducer(
		{
			key: 'encarpay.apply',
		},
		apply,
	),
	method: encryptPersistReducer(
		{
			key: 'encarpay.method',
			whitelist: ['authorizedApplication', 'encarpayType'],
		},
		method,
	),
});

export default encarpay;
